import cloneDeep from 'lodash/fp/cloneDeep';
import BusinessService from '../services/businessService';

const initialState = {
  chosenLocation: null,
  chosenLanguage: null,
  chosenGender: null,
  chosenRoute: null,
  chosenBeverage: null,
  chosenTimeOfDay: null,
  comments: null,
  settings: {
    languageOptions: [],
    beverageOptions: [],
    genderOptions: [],
    testDriveRoutes: [],
  },
  driveDate: null,
  importantFeatures: null,
  // Possible value include: 'home', 'dealership' and 'selectLocation'
  testDriveAppRoute: 'dealership',
};

const getters = {
  chosenRoute: state => state.chosenRoute,
  chosenBeverage: state => state.chosenBeverage,
  chosenTimeOfDay: state => state.chosenTimeOfDay,
  driveDate: state => state.driveDate,
  chosenLocation: state => state.chosenLocation,
  testDriveAppRoute: state => state.testDriveAppRoute,
  isFromHomeRoute: state => state.testDriveAppRoute === 'home' || state.chosenLocation === 'home',
};

const mutations = {
  SET_CHOSEN_LOCATION(state, value) {
    state.chosenLocation = value;
  },
  SET_CHOSEN_LANGUAGE(state, value) {
    state.chosenLanguage = value;
  },
  SET_CHOSEN_GENDER(state, value) {
    state.chosenGender = value;
  },
  SET_CHOSEN_BEVERAGE(state, value) {
    state.chosenBeverage = value;
  },
  SET_CHOSEN_ROUTE(state, value) {
    state.chosenRoute = value;
  },
  SET_CHOSEN_TIME_OF_DAY(state, value) {
    state.chosenTimeOfDay = value;
  },
  SET_COMMENTS(state, value) {
    state.comments = value;
  },
  SET_SETTINGS(state, value) {
    state.settings = value;
  },
  SET_DRIVE_DATE(state, value) {
    state.driveDate = value;
  },
  SET_IMPORTANT_FEATURES(state, value) {
    state.importantFeatures = value;
  },
  SET_TEST_DRIVE_APP_ROUTE(state, value) {
    state.testDriveAppRoute = value;
  },
};

const actions = {
  async getTestDriveSettings({ rootState, state, commit }) {
    const { business } = rootState;
    const res = await BusinessService.getIntegrationSettings(business.api.key, business.api.externalID);
    const { testDriveSettings } = res.data;
    commit('SET_SETTINGS', {
      ...state.settings,
      ...testDriveSettings,
    });
    return res;
  },
};

export default {
  namespaced: true,
  state: cloneDeep(initialState),
  mutations,
  actions,
  getters,
};
